import { render } from "./ProductTypeActionMenu.vue?vue&type=template&id=ab04b2be&scoped=true"
import script from "./ProductTypeActionMenu.vue?vue&type=script&lang=js"
export * from "./ProductTypeActionMenu.vue?vue&type=script&lang=js"

import "./ProductTypeActionMenu.vue?vue&type=style&index=0&id=ab04b2be&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab04b2be"]])

export default __exports__